import { logger } from '../../../utils'
import { Reward } from '../types'
import { doVoucherPlusUrlRedemptionFlow } from './voucherPlusUrl'

export const doWinesVoucherRedemptionFlow = (reward: Reward) => async (dispatch) => {
  logger.log(`doWinesVoucherRedemptionFlow(${reward.rewardId}, ${reward.rewardParentId})`)
  logger.log('Redirecting to voucherPlusUrl flow')
  dispatch(doVoucherPlusUrlRedemptionFlow(reward))
}
